import request, {
    post,
    get,
    postFormData,
    requestData
} from "../utils/request";
import { clearObjEmptyStr } from "@/utils"
function protocolHandler (res) {
    return typeof res === 'string' ? res.replace(/^https?:/g, '') : res
}
// 文件上传
export const uploadFile = (params, progressEvent) => {
    return postFormData("/Website/File/fileUpload", params, progressEvent);
};

// 机构知识点
export const fetchOrgInfo = (params) => {
    return post("/Website/Basic/getOrganGroupInfo", params);
};
/* ------------------------管理试题------------------------------- */
// 获取试题列表
export const fetchQueList = (params) => {
    return request({
        url: "/Website/ExamSubject/GetList",
        params,
        method: "POST"
    });
};

// 删除试题
export const deleteQue = (params) => {
    return post("/Website/ExamSubject/updateSubjectState", params, true);
};

// 编辑试题
export const updateQue = (params) => {
    return request({
        url: "/Website/ExamSubject/Update",
        method: "POST",
        data: params
    });
};

// 获取试题详情
export const fetchQueDetails = (params) => {
    return get("/Website/ExamSubject/GetById", params);
};

// 创建试题
export const createQue = (params) => {
    return post("/Website/ExamSubject/Create", params);
};

// 批量创建试题
export const batchCreateQue = (data) => {
    return post("/Website/ExamSubject/BatchCreate", undefined, undefined, data);
};

// 随机抽题
export const queSampling = (params) => {
    return request({
        url: "/Website/ExamSubject/RandomStruct",
        params,
        method: "POST"
    });
};

/* ------------------------管理试卷------------------------------- */

// 获取试卷列表
export const fetchPaperList = (params) => {
    return request({
        url: "/Website/ExamPaper/GetList",
        params,
        method: "POST"
    });
};

// 删除试卷
export const deletePaper = (params) => {
    return post("/Website/ExamPaper/updatePaperState", params);
};

// 获取试卷详情
export const fetchPaperDetails = (params) => {
    return get("/Website/ExamPaper/GetById", params);
};

// 创建试卷
export const createPaper = (params) => {
    return requestData({
        method: "POST",
        url: "/Website/ExamPaper/Create",
        data: params
    });
};

// 机构抽题
export const organSampling = (params) => {
    return request({
        url: "/Website/ExamSubject/ManualStruct",
        params,
        method: "POST"
    });
};

// 系统抽题
export const systemSampling = (params) => {
    return request({
        url: "/Website/ExamSubject/SystemStruct",
        params,
        method: "POST"
    });
};

// 随机抽卷
export const paperSampling = (params) => {
    return request({
        url: "/Website/ExamSubject/RandomFexible",
        params,
        method: "POST"
    });
};

// 更新试卷
export const updatePaper = (params) => {
    return request({
        url: "/Website/ExamPaper/Update",
        method: "POST",
        data: params
    })
};

/* ------------------------管理考试------------------------------- */

// 考试列表
export const examGetList = (params) => {
    return request({
        url: "/Website/Exam/GetList",
        params,
        method: "POST"
    });
};

// 批量更改考试状态
export const updateExamState = (params) => {
    return post("/Website/Exam/updateExamState", params);
};

// 获取考试详情
export const examGetById = (params) => {
    return get("/Website/Exam/GetById", params);
};

// 批阅考试列表
export const MarkExamPaper = (params) => {
    return request({
        url: "/Website/Exam/MarkExamPaper",
        params,
        method: "POST"
    });
};

// 批阅考试-学生列表
export const MarkStudentList = (params) => {
    return request({
        url: "/Website/Exam/MarkStudentList",
        params,
        method: "POST"
    });
};

// 获取待批改的试卷
export const GetMarkStudentById = (params) => {
    return post("/Website/Exam/GetMarkStudentById", params);
};

// 提交人工阅卷
export const MarkStudentDetail = (params) => {
    request({
        url: "/Website/Exam/MarkStudentDetail",
        data: JSON.stringify(params),
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        }
    });
};

// 更新考试信息
export const ExamUpdate = (params) => {
    return post("/Website/Exam/Update", params);
};

// 更新考试信息
export const ExamCreate = (params) => {
    return post("/Website/Exam/Create", params);
};

// 预览考试
export const PreviewExamById = (params) => {
    return post("/Website/Exam/PreviewExamById", params);
};

// 成绩列表
export const ScoreManage = (params) => {
    return request({
        url: "/Website/Exam/ScroreManage",
        params,
        method: "POST"
    });
};

// 考试试卷成绩列表
export const MarkPaperList = (params) => {
    return request({
        url: "/Website/Exam/MarkPaperList",
        params,
        method: "POST"
    });
};

// 成绩统计列表
export const ScoreStatisticsList = (params) => {
    return request({
        url: "/Website/Score/GetList",
        params,
        method: "POST"
    });
};

// 成绩统计-分数段统计
export const GetScoreStage = (params) => {
    return post("/Website/Score/GetScoreStage", params);
};

// 成绩统计-排名
export const GetRanking = (params) => {
    return post("/Website/Score/GetRanking", params);
};

// 成绩统计-报告
export const GetReport = (params) => {
    return post("/Website/Score/GetReport", params);
};

// 成绩统计-排名
export const GetCandidate = (params) => {
    return request({
        url: "/Website/Exam/Candidate",
        params,
        method: "POST"
    });
};

/* ------------------------路由管理------------------------------- */

// 批量更改考试状态
export const getModularByUserId = (params) => {
    return post("/Website/User/GetModularByUserId", params);
};

// 获取管理端的课程列表
export function getProjectList (params) {
    return post("/Manage/CustomSource/GetListForWeb", params, false, { data: JSON.stringify(params) })
}

// 获取课程列表
export function getSourceList (params) {
    Object.keys(params).forEach(key => {
        if (params[key] === "") params[key] = undefined
    })
    return post("/Manage/CustomSource/GetList", params, true, params)
}

// 启用，禁用课程
export function enableCourse (SourceIds, SourceState) {
    return post("/Manage/CustomSource/BatchSetSourceState", { SourceIds, SourceState }, false, {
        SourceIds,
        SourceState
    })
}

// 从word导入试卷模板
export function importPaperFromWord (url) {
    return post("/Website/ExamPaper/ImportFromWord", { url }, undefined, { url })
}

// 导出为word模板
export function exportPaper (paperId) {
    return post("/Website/ExamPaper/ExportToWord", { paperId }, undefined, { paperId }).then(protocolHandler)
}

// 从word导入试卷模板
export function importQuestionFromWord (url) {
    return post("/Website/ExamSubject/ImportFromWord", { url }, undefined, { url })
}

// 导出为word模板
export function exportQuestions (subjectIds) {
    return post("/Website/ExamSubject/ExportToWord", { subjectIds }, undefined, { subjectIds }).then(protocolHandler)
}

// 创建课程
export function createProject (data) {
    return post("/Manage/CustomSource/CreateCustomSource", { data }, undefined, data)
}

// 获取课程详情
export function getSourceDetail (SourceId) {
    return postFormData("/Manage/CustomSource/GetCustomSourceByIdForEdit", { SourceId })
}

// 获取课程简单详情
export function getCourseStatDetail (SourceId) {
    return postFormData("/Manage/CustomSource/GetCustomSourceByIdForView", { SourceId })
}

// 获取课程简单详情
export function getCourseJoinPeopleList (params) {
    return post("/Manage/CustomSource/GetJoinPeopleList", params, true, params)
}
// 下载某课程参与人员列表
export function exportCourseJoinPeopleList (SourceId) {
    return post("/Manage/CustomSource/DownloadJoinPeopleList", { SourceId }, undefined, { SourceId })
}
// 获取文件导入日志列表
export function getFileLogList (params) {
    return post("/Api/Organ/GetFileLogList", clearObjEmptyStr(params), true, clearObjEmptyStr(params))
}
// 删除文件日志
export function delFileLog (id) {
    return post("/Api/Organ/DelFileLogList", { id }, undefined, { id })
}
// 增加学习时长
export function addLeanTime (SourceId, LeanTime) {
    return post("/Manage/CustomSource/AddLeanTime", { SourceId, LeanTime }, undefined, { SourceId, LeanTime })
}

export function uploadCourse (params, progressEvent) {
    return postFormData("/Website/File/UploadS3", params, progressEvent)
}

// 导出成绩
export function MarkPaperListExportToExcel (data) {
    return post("/Website/Exam/MarkPaperListExportToExcel", {}, false, data)
}
// 导出考试试卷（包含答案）
export function addTaskExportWithAnswerToWord (data) {
    return post("/Website/ExamPaper/addTaskExportWithAnswerToWord", {}, false, data)
}
// 试卷导出记录列表
export function GetDownLoadExamPaperWithStudentAnswerList (data) {
    let clearNullData = {}
    for (const key in data) {
        if (data[key]) {
            clearNullData[`${key}`] = data[key]
        }
    }
    data = clearNullData
    return post("/Website/JobTask/GetDownLoadExamPaperWithStudentAnswerList", {}, true, data)
}
// 删除试卷导出记录信息
export function DelJobTask (id) {
    return post("/Website/JobTask/Delete", id, true)
}

// 获取管理首页统计数据
export function getStatData () {
    return post("Website/Report/HomeChartReport")
}

// 获取机构课程分析
export function getStatCourseReport (classId) {
    const params = {
        classId
    }
    return post("/Website/Report/CustomSourceChartReport", params, false, params)
}
// 获取机构考试分析
export function getStatExamReport (classId) {
    const params = {
        classId
    }
    return post("/Website/Report/ExamChartReport", params, false, params)
}

// 获取机构试卷分析
export function getStatPaperReport (classId) {
    const params = {
        classId
    }
    return post("/Website/Report/ExamPaperChartReport", params, false, params)
}
// 获取机构学员分析
export function getStatStudentReport () {
    return post("/Website/Report/StudentChartReport")
}

// 获取机构试题分析
export function getStatSubjectReport (subjectTypeId) {
    const params = {
        subjectTypeId
    }
    return post("/Website/Report/SubjectChartReport", params, false, params)
}
// 机构课程分析导出
export function exportCourseReport () {
    return post("/Website/Report/CustomSourceChartReportXls").then(protocolHandler)
}

// 机构试卷分析导出
export function exportPaperReport () {
    return post("/Website/Report/ExamPaperChartReportXls").then(protocolHandler)
}
// 机构学员分析导出
export function exportStudentReport () {
    return post("/Website/Report/StudentChartReportXls").then(protocolHandler)
}

// 机构试题分析导出
export function exportSubjectReport () {
    return post("/Website/Report/SubjectChartReportXls").then(protocolHandler)
}
// 机构考试分析导出
export function exportExamReport () {
    return post("/Website/Report/ExamChartReportXls").then(protocolHandler)
}

// 批量导出学生成绩 data为考试id所组成的数组
export function exportStudentAchievement (data) {
    return post("/Website/Exam/MarkPaperListsExportToExcel", data, false, data).then(protocolHandler)
}
